// @flow
import { Field, FieldProps } from 'formik';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { FieldWrapper } from 'speed-js-react-web';
import BaseSelect from 'esm-web-pro/components/forms/fields/BaseSelect';

type Props = {
    lineKey: string,
    choices: {
        [id: string]: string,
    },
    value: ?string,
    startNumber: number,
    endNumber: number,
    onChange: Function,
    disabled: boolean,
}

const CablePipeField = (props: Props) => {
    const {
        lineKey: key, choices, startNumber, endNumber, value, onChange, disabled,
    } = props;

    return (
        <Field
            name={key}
            key={key}
        >
            {(field: FieldProps) => (
                <FieldWrapper
                    label={(
                        <FormattedMessage
                            id="line-number-cable-pipe"
                            defaultMessage="Line {number} - {number1}"
                            values={{
                                number: startNumber,
                                number1: endNumber,
                            }}
                        />
                    )}
                    // label={`Line ${number} - ${number + 1}`}
                    name={key}
                    required
                    {...field}
                >
                    <BaseSelect
                        name={field.field.name}
                        emptyLabel={(
                            <FormattedMessage
                                id="cable-pipe-select"
                                defaultMessage="Select pipe..."
                            />
                        )}
                        choices={choices}
                        value={value}
                        onChange={(choice) => {
                            field.form.setFieldValue(key, choice);
                            onChange(choice);
                        }}
                        disabled={disabled}
                        additionalStyles={
                            (!disabled && !value) && ({
                                control: (provided) => ({
                                    ...provided,
                                    minHeight: 30,
                                    borderColor: 'red',
                                    '&:hover': {
                                        borderColor: 'red',
                                    },
                                }),
                            })
                        }
                        menuPlacement="auto"
                        menuPortalTarget={document.querySelector('#root > div')}
                    />
                </FieldWrapper>
            )}
        </Field>
    );
};

export default CablePipeField;
